module.exports = __webpack_public_path__ + "static/img/IMG_20241205_203114.72b5aed7.jpg";